<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        MHD-Kontrolle abschließen
      </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>

    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper" v-if="!isLoading">

      <v-btn
          class="sent-inventory_btn"
          @click="issueMHDControl"
          :disabled="mhdCumulatedControlLists.length === 0"
      >
        <mdh-icon style="width: 40px; color:white; margin-right: 10px;"/>
        <span>MHD-Kontrolle abschließen</span>
      </v-btn>

      <v-expansion-panels class="checkoutCartOverview"
                          flat accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            Details zur MHD-Kontroll-Liste
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <v-virtual-scroll class="inventory-total-list_v-scroll" item-height="181"
                              bench="5"
                              :items="mhdCumulatedControlLists"
                              v-if="mhdCumulatedControlLists.length > 0"
            >
              <template v-slot:default="{index, item}">
                <v-card class="article-card_no-img-full-borders" :key="index">
                  <div class="article-card__desc-no-img">
                    {{ item.description }}
                  </div>
                  <div class="article-card__itemNo-no-img">
                    Artikelnummer: {{ item.itemNo }}
                  </div>
                  <div class="article-card__ordered-type-no-img">
                    {{ item.amount }} {{ item.unit | capitalize}}
                  </div>
                  <div class="article-card__price-no-img">
                      Ablaufdatum:  {{ parseDateToUsable(item.mhdDate) }}
                  </div>
                </v-card>
                <v-btn class="v-scroll_btn-delete" @click="removeFromMHDList(item, index)">
                  <TrashCan/>
                </v-btn>
              </template>

            </v-virtual-scroll>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import router from "@/router";
import TrashCan from "@/assets/cart/trashCan";
import axios from "axios";
import MdhIcon from "@/assets/mhd/mdhIcon.vue";
export default {
  name: "mhdInventoryCheckout",
  components: {MdhIcon, TrashCan},
  data() {
    return {
      isLoading: true,
      depositValues: null,
      depositDialog: false,
      depositCheck: false,
      mhdCumulatedControlLists: []
    }
  },

  methods: {
    ...mapActions('inventory', {
      getDepositValues: 'getDepositValues',
      addArticleToInventory: 'addArticleToInventory',
      removeFromInventory: 'removeFromInventory',
      fetchTotalInventory: 'fetchTotalInventory',
      fetchPersonalInventory: 'fetchPersonalInventory'
    }),

    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      setLoadingState: 'setLoadingState',
      setOverlay: 'setOverlay'
    }),

    ...mapActions('mhdInventory', {
        fetchAllOpenControlLists: 'fetchAllOpenControlLists',
        removeItemFromOpenControlList: 'removeItemFromOpenControlList',
        createFinalControlList: 'createFinalControlList'
    }),


    ...mapMutations('inventory', {
      setInventoryAvailable: 'setInventoryAvailable',
      setInventoryMode: 'setInventoryMode'
    }),

    goBack() {
      router.go(-1)
    },

    parseDateToUsable(value) {
        if(!value) {
            return
        }
        let splitted = value.toString().split('-')
        return splitted[2]+'.'+splitted[1]+'.'+splitted[0]
    },

    issueMHDControl() {
      this.setOverlay({
          visibility: true,
          state: 'mhd_control_list'
      })
      this.createFinalControlList().then((r) => {
          if(r) {
              this.setOverlay({
                  overlayVisibility: false,
                  overlayContent: null
              })
              router.push({name: 'LastArticle'})
          } else {
              this.setOverlay({
                  overlayVisibility: true,
                  overlayContent: 'mhd_control_list_error'
              })
              setTimeout(() => {
                  this.setOverlay({
                      overlayVisibility: false,
                      overlayContent: null
                  })
              }, 3000)
              alert('Es ist')
          }
      })
    },

    fetchCumulatedOpenControlLists() {
      this.fetchAllOpenControlLists().then(r => {
          let temp = []
          r.forEach(el => {
              let list = JSON.parse(el.control_list)
              let index = 0
              list.map(listEl => {
                  listEl.parentId = el.id
                  listEl.internalId = index
                  index++
              })
              temp.push(...list)
          })
          this.mhdCumulatedControlLists = temp
      })
    },

    removeFromMHDList(item, index) {
      this.mhdCumulatedControlLists.splice(index, 1)

      axios.get('api/mhd-control/remove-from-cumulated-list/'+item.parentId+'/'+item.internalId).then(r => {
          if(r.data.status === 0) {
              r = r.data.control_lists
              let temp = []
              r.forEach(el => {
                  let list = JSON.parse(el.control_list)
                  let index = 0
                  list.map(listEl => {
                      listEl.parentId = el.id
                      listEl.internalId = index
                      index++
                  })
                  temp.push(...list)
              })
              this.mhdCumulatedControlLists = temp
          }
      })
    }
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    }),

    ...mapGetters('mhdInventory', {
        getMHDInventoryItems: 'getMHDInventoryItems'
    }),
  },

  mounted() {
    this.setHeaderVisibility(false)
    this.fetchAllOpenControlLists().then(r => {
        r.forEach(el => {
            let list = JSON.parse(el.control_list)
            let index = 0
            list.map(listEl => {
                listEl.parentId = el.id
                listEl.internalId = index
                index++
            })
            this.mhdCumulatedControlLists.push(...list)
        })
        this.isLoading = false
    })
  }
}
</script>

<style>

.inventory-total-list_v-scroll {
  margin-top: 4px;
}

.article-card_no-img-full-borders {
  border-radius: 30px!important;
  height: 169px;
  width: 100%;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 33px 39px 33px 40px;
  background-color: white;
  border-radius: 30px;
  overflow: hidden;
  padding: 12px 16px;
}

.inventory-deposit-dialog {
  border-radius: 30px!important;
  background-color: white;
  border: 3px solid white;
  max-width: 700px!important;
}

.inventory-deposit-dialog .depositListContainer {
  display: grid!important;
}


@media all and (max-width: 700px) {
  .close-btn-deposit-inventory {
    position: fixed;
    background-color: var(--igros-red) !important;
    right: 35px;
    bottom: calc((100vh * 0.1) / 2 - 22px);
    width: 100px;
  }
}
@media all and (min-width: 701px) {
  .close-btn-deposit-inventory {
    position: fixed;
    background-color: var(--igros-red) !important;
    right: calc((100vw - 700px) / 2 + 15px);
    bottom: calc((100vh * 0.1) / 2 - 22px);
    width: 100px;
  }
}

.add-deposit-inventory_btn {
  float: right;
  margin-bottom: 15px;
  margin-top: 20px;
  height: 44px!important;
}

.sent-inventory_btn {
  float: right;
  margin-bottom: 15px;
  margin-left: 100%;
  height: 44px!important;
  background-color: var(--igros-red) !important;

}

.v-scroll_btn-delete {
  height: 50px!important;
  min-width: 50px!important;
  width: 50px;
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.inventory-dialog_btn-left {
  background-color: var(--igros-slightgrey)!important;
  position: relative;
  top: -22px;
  left: -35px;
}

.inventory-dialog_btn-right {
  background-color: var(--igros-red)!important;
  position: relative;
  top: -22px;
  right: -35px;
}

.v-sheet.inventory-dialog__card {
  padding: 15px 15px 40px 15px;
  text-align: left;
}

.inventory-dialog {
  box-shadow: none!important;
}

</style>
